import * as React from 'react';
import { ProductSizeInterface } from '../../../../../../Interface/ProductSize';


export default function NcwProductButton({
  product_size,
}: {
  product_size: ProductSizeInterface;
}) {
  return (
    <>
      {product_size.is_ncw_product_size && (
        <a href={product_size.ncw_link ?? ''} style={{ textDecoration: 'none' }}>
          <div
            className="w-100 px-3 py-2 text-center fw-bold fst-italic text-black"
            style={{ backgroundColor: '#07e506' }}
          >
            NCW Product
          </div>
        </a>
      )}
    </>
  );
}
